// extracted by mini-css-extract-plugin
export default {"LoadingView":"Loading_LoadingView__hFi6J","delayFadeIn":"Loading_delayFadeIn__0abZX","shine":"Loading_shine__FlWfE","dotAnim":"Loading_dotAnim__FTN+Y"};